import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { CheckCircle2, PlayCircle } from 'lucide-react';
import { getAulaProgress } from '@/hooks/useMasterClassProgress';
import { cn } from '@/lib/utils';
import type { Aula } from '@/types/masterclass';

interface SerieSidebarProps {
  aulas: Aula[];
  currentAulaId: string;
  serieId: string;
  onSelect: (aulaId: string) => void;
}

export function SerieSidebar({
  aulas,
  currentAulaId,
  serieId,
  onSelect,
}: SerieSidebarProps) {
  useLanguage();
  return (
    <div className="space-y-2" role="list">
      <h3 className="text-sm font-medium mb-3">{translateInterfaceText("Aulas")}</h3>
      {aulas.map((aula, index) => {
        const { status } = getAulaProgress(aula.id, serieId);
        const isActive = aula.id === currentAulaId;
        const isCompleted = status === 'concluida';

        return (
          <button
            key={aula.id}
            onClick={() => onSelect(aula.id)}
            className={cn(
              'w-full text-left p-3 rounded-lg transition-colors',
              'border border-transparent',
              isActive && 'border-l-4 border-l-primary bg-accent',
              !isActive && 'hover:bg-accent/50'
            )}
            role="listitem"
          >
            <div className="flex items-start gap-3">
              {/* Indicador */}
              <div className="flex-shrink-0 mt-0.5">
                {isCompleted ? (
                  <CheckCircle2 className="h-5 w-5 text-success-500" />
                ) : isActive ? (
                  <PlayCircle className="h-5 w-5 text-primary" />
                ) : (
                  <span className="flex items-center justify-center h-5 w-5 text-xs font-medium text-muted-foreground">
                    {index + 1}
                  </span>
                )}
              </div>

              {/* Título */}
              <div className="flex-1 min-w-0">
                <p
                  className={cn(
                    'text-sm font-medium line-clamp-2',
                    isActive ? 'text-foreground' : 'text-muted-foreground'
                  )}
                >
                  {aula.titulo}
                </p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
